import { useBlackfeo } from "@/hooks/use-blackfeo";
import { BlackfeoPopup } from "@/components/blackfeo/BlackfeoPontos";
import { BLACK_CTA_VENDA, BLACK_ULTIMOS_DIAS } from "@/lib/black2x1/escassez";
import { useEffect, useState } from "react";
import { ArrowRight, X } from "lucide-react";

import logoBlack from "@/assets/black2x1/black-logo-oficial.webp.asset.json";
import { BLACK_FIM } from "@/components/blog/PosCta";
import { blackListaHref } from "@/lib/black2x1/origem-visita";
import { useBlackSale } from "@/hooks/use-black-sale";

/** Pop-up da BLACK 2x1 nos artigos: aparece uma vez ao passar de 50% da leitura (igual às LPs do Wix). */
export function BlackPopupRolagem({ origem = "efisio", modo = "saida" }: { origem?: string; modo?: "rolagem" | "saida" }) {
  const blackfeo = useBlackfeo();
  return blackfeo ? <BlackfeoPopup ponto={origem} modo={modo} /> : <BlackDobroPopup origem={origem} />;
}

function BlackDobroPopup({ origem }: { origem: string }) {
  const sale = useBlackSale();
  const [aberto, setAberto] = useState(false);

  useEffect(() => {
    if (Date.now() > BLACK_FIM) return;
    const KEY = "feo-b26-popup";
    try { if (sessionStorage.getItem(KEY)) return; } catch {}
    let mostrado = false;
    const mostrar = () => {
      if (mostrado) return;
      mostrado = true;
      try { sessionStorage.setItem(KEY, "1"); } catch {}
      setAberto(true);
      limpar();
    };
    const onScroll = () => {
      const h = document.documentElement;
      if ((h.scrollTop + window.innerHeight) / h.scrollHeight > 0.5) mostrar();
    };
    const onSaida = (e: MouseEvent) => { if (!e.relatedTarget && e.clientY <= 0) mostrar(); };
    const limpar = () => {
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseout", onSaida);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("mouseout", onSaida);
    return limpar;
  }, []);

  useEffect(() => {
    if (!aberto) return;
    const onKey = (e: KeyboardEvent) => e.key === "Escape" && setAberto(false);
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [aberto]);

  if (!aberto) return null;
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="BLACK 2x1: a maior oferta da nossa história"
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 p-4"
      onClick={(e) => e.target === e.currentTarget && setAberto(false)}
    >
      <div
        className="relative w-full max-w-md rounded-2xl bg-[#0b0a14] px-6 py-9 text-center text-white shadow-2xl"
        style={{ backgroundImage: "radial-gradient(circle at 100% 0%, rgba(124,58,237,0.4), transparent 55%)" }}
      >
        <button type="button" aria-label="Fechar" onClick={() => setAberto(false)} className="absolute right-3 top-3 rounded-full p-1.5 text-white/70 hover:bg-white/10 hover:text-white">
          <X className="h-5 w-5" />
        </button>
        {sale ? (
          <p className="flex items-center justify-center gap-1.5 text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#2fe0d6] sm:text-xs">🔥 {BLACK_ULTIMOS_DIAS} · vendas abertas</p>
        ) : (
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-[#2fe0d6]">BLACK 2x1 · 2026</p>
        )}
        <img src={logoBlack.url} alt="Pós FEO em Dobro" decoding="async" className="mx-auto mt-4 h-auto w-60" />
        <p className="mt-4 bg-gradient-to-r from-[#a78bfa] to-[#e9a8f5] bg-clip-text text-xl font-extrabold text-transparent">
          A maior oferta da nossa história
        </p>
        <div className="mt-4 space-y-1 text-base font-bold">
          <p>2 pós-graduações.</p>
          <p>Pague apenas 1.</p>
          <p>Acesso vitalício à Star Cursos.</p>
        </div>
        <a
          href={blackListaHref(`${origem}-popup`)}
          className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#2fe0d6] px-7 py-3 text-sm font-extrabold uppercase tracking-wide text-[#0b0a14] hover:brightness-110"
        >
          {sale ? BLACK_CTA_VENDA : "Saiba mais"} <ArrowRight className="h-4 w-4" />
        </a>
      </div>
    </div>
  );
}
